import { render, staticRenderFns } from "./CompTeacherStats.vue?vue&type=template&id=7241d653"
import script from "./CompTeacherStats.vue?vue&type=script&lang=js"
export * from "./CompTeacherStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports